import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'
import { AddNumberFromAppStepsProvider } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppStepsContext'

const AddNumberFromAppProviderLayoutContent = observer(() => {
  return (
    <>
      <Outlet />
    </>
  )
})

export const AddNumberFromAppProviderLayout = () => {
  const numbersLayerStore = useNumbersLayerContext()

  return (
    <AddNumberFromAppStepsProvider numbersLayerStore={numbersLayerStore}>
      <AddNumberFromAppProviderLayoutContent />
    </AddNumberFromAppStepsProvider>
  )
}
